export function replaceInString(string, replacements = {}) {
	return Object.keys(replacements).reduce((string, key) => {
		const value = replacements[key]
		const pattern = new RegExp(`{{\\s*${key}\\s*}}`)
		return string.replace(pattern, value)
	}, string)
}